import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/Layout";
import LayoutBanner from "../components/Layout/LayoutBanner";
import { Box, Grid, Stack, TextField, Typography } from "@mui/material";
import "../css/api_config.css";
import banner from "../assets/banner_apiconfig.svg";
import { useDispatch, useSelector } from "react-redux";
import { getConfig } from "../redux/slices/authSlice";
import Loader from "../components/Loader/Loader";
import { maskHalfText, maskText } from "../utils/helper";
import api from '../Api'
const ApiConfig = () => {
  const api_Config = useSelector((state) => state.auth.api_Config);
  const isLoading = useSelector((state) => state.auth.isLoading);
  const authData = useSelector((state) => state.auth.data);
  const dispatch = useDispatch();
  useEffect(() => {
    if (authData.access_token !== "") {
      api.defaults.headers.common.Authorization = authData?.access_token
        ? `Bearer ${authData?.access_token}`
        : "";
      dispatch(getConfig());
    }
  }, [dispatch, authData]);
  return (
    <Layout>
      <LayoutBanner
        title={"API Configuration"}
        body={
          "This page presents the API details used for backend server updates. Although users can view these details, all fields are read-only and cannot be modified."
        }
        image={banner}
      />
      <Loader message={"Loading"} show={isLoading} />
      <Grid container className="api_config">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          display={"flex"}
          justifyContent={"space-between"}
        >
          <Typography className="heading">API Configuration</Typography>
        </Grid>

        <Grid container p={3} className="card api_config" marginTop={2}>
          <Grid item md={4}>
            <Typography
              fontSize={20}
              fontWeight={700}
              color={"#358ad4"}
              display={"flex"}
              alignItems={"baseline"} 
              marginLeft={"50% !important"}
            >
              Classe 365
            </Typography>
          </Grid>
          <Grid item md={8}>
            <Grid container>
              <Grid md={2} item display={"flex"} alignItems={"center"}>
                <Typography>API Host URL</Typography>
              </Grid>
              <Grid md={10} item>
                <TextField
                  type="text"
                  sx={{ width: "80%",background:"#F5F8FA !important" }}
                  margin="dense"
                  value={
                    api_Config?.CLASSE_API_ENDPOINT
                    &&
                    maskHalfText(api_Config?.CLASSE_API_ENDPOINT)

                  }
                  disabled
                />
              </Grid>
              <Grid md={2} item display={"flex"} alignItems={"center"}>
                <Typography>User Name</Typography>
              </Grid>
              <Grid md={10} item>
                <TextField
                  type="text"
                  sx={{ width: "80%",background:"#F5F8FA" }}
                  margin="dense"
                  value={api_Config?.CLASSE_API_USERNAME}
                  disabled
                />
              </Grid>
              <Grid md={2} item display={"flex"} alignItems={"center"}>
                <Typography>Password</Typography>
              </Grid>
              <Grid md={10} item>
                <TextField
                  type="text"
                  sx={{ width: "80%",background:"#F5F8FA" }}
                  margin="dense"
                  value={
                    api_Config?.CLASSE_API_PASSWORD &&
                    maskText(api_Config?.CLASSE_API_PASSWORD)
                  }
                  disabled
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} marginTop={2}>
            <Typography
              fontSize={20}
              fontWeight={700}
              color={"#358ad4"}
              display={"flex"}
              alignItems={"baseline"}
              marginLeft={"50% !important"}
            >
              SkyPrep
            </Typography>
          </Grid>
          <Grid item md={8} marginTop={3}>
            <Grid container>
              <Grid md={2} item display={"flex"} alignItems={"center"}>
                <Typography>API Host URL</Typography>
              </Grid>
              <Grid md={10} item>
                <TextField
                  type="text"
                  sx={{ width: "80%",background:"#F5F8FA" }}
                  margin="dense"
                  value={
                    api_Config?.SKYPREP_API_ENDPOINT
                    &&
                    maskHalfText(api_Config?.SKYPREP_API_ENDPOINT)

                  }
                  disabled
                />
              </Grid>
              <Grid md={2} item display={"flex"} alignItems={"center"}>
                <Typography>API Key</Typography>
              </Grid>
              <Grid md={10} item>
                <TextField
                  type="text"
                  sx={{ width: "80%",background:"#F5F8FA" }}
                  margin="dense"
                  value={
                    api_Config?.SKYPREP_API_KEY &&
                    maskHalfText(api_Config?.SKYPREP_API_KEY)
                  }
                  disabled
                />
              </Grid>
              <Grid md={2} item display={"flex"} alignItems={"center"}>
                <Typography>Account Key</Typography>
              </Grid>
              <Grid md={10} item>
                <TextField
                  type="text"
                  sx={{ width: "80%",background:"#F5F8FA" }}
                  margin="dense"
                  value={
                    api_Config?.SKYPREP_ACCOUNT_KEY &&
                    maskHalfText(api_Config?.SKYPREP_ACCOUNT_KEY)
                  }
                  disabled
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
};

export default ApiConfig;
